import component from '.';
import { DEFAULT_EDITORS_FIT_DATA_ORDER } from "../../../../lib/utils/consts";

/** @type {UICore.ComponentMeta} */
const CheckboxComponentMeta = {
  id: 'checkbox',
  name: '勾选框',
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-checkbox_1636363113638.png',
  category: '编辑框',
  component,
  bindings: [{
    id: 'v-model',
    main: true,
    required: true,
    prop: 'value',
    event: 'change',
    checkData: s => s.type === 'boolean'
  }],
  isFormEditor: true,
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'value',
      type: 'boolean'
    }, {
      id: 'readonly',
      type: 'boolean',
      title: '只读'
    }, {
      id: 'label',
      type: 'string',
      title: '标签文字'
    }]
  },
  events: [{
    id: 'change',
    name: '修改',
    desc: '勾选状态变化时。 `$event` 为新的值（布尔值）',
    arguments: [{
      type: 'boolean',
      description: '修改后的值'
    }]
  }],
  fitData({
    dataSchema,
    dataPath
  }) {
    if (dataSchema.type !== 'boolean') return null;
    return {
      type: 'editor',
      order: DEFAULT_EDITORS_FIT_DATA_ORDER,
      layout: {
        type: 'checkbox',
        bindings: {
          'v-model': dataPath
        },
        props: {
          label: dataSchema.title || String(dataSchema.id)
        }
      }
    };
  }
};
export default CheckboxComponentMeta;
//# sourceMappingURL=meta.js.map
